import React from 'react'
import { Link } from 'react-router-dom'

const ErrorPage = () => {
  return (
    <div style={{marginLeft:'600px',marginTop:'200px'}}>
     <h1>404 Error</h1>
    
    <Link to='/'><button>Back to home</button></Link>
    </div>
  )
}

export default ErrorPage
